import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRentFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: "16px",
	height: "16px",
	viewBox: "0 0 16 16",
	style: { enableBackground: "new 0 0 16 16" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill:#FFED00;}\n"
	}), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M12.24,3.76V2.35h2.82v2.35H0.94V2.35h2.82v1.41h0.94V2.35h6.59v1.41H12.24z M11.29,0v1.41H4.71V0H3.76v1.41H0 V16h16V1.41h-3.76V0H11.29z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M4.71,13.65h1.16v-0.89h0.82v-0.68h0.71v-0.61h0.7v-0.72h0.44l0.36-0.36c0.37,0.15,0.77,0.17,1.15,0.06 c0.38-0.11,0.71-0.35,0.93-0.68c0.22-0.33,0.33-0.72,0.3-1.12c-0.03-0.4-0.2-0.77-0.47-1.05c-0.27-0.29-0.64-0.47-1.03-0.52 S8.99,7.11,8.66,7.32c-0.34,0.21-0.59,0.53-0.72,0.9C7.8,8.59,7.8,9,7.94,9.37l-3.23,3.14L4.71,13.65z" }),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M9.7,8.79c0.08,0.05,0.18,0.08,0.27,0.08c0.13,0,0.26-0.05,0.35-0.14c0.09-0.09,0.14-0.22,0.14-0.35 c0-0.1-0.03-0.19-0.08-0.27c-0.05-0.08-0.13-0.14-0.22-0.18c-0.09-0.04-0.19-0.05-0.29-0.03C9.79,7.91,9.7,7.96,9.63,8.03 C9.56,8.09,9.51,8.18,9.49,8.28c-0.02,0.1-0.01,0.2,0.03,0.29C9.56,8.65,9.62,8.73,9.7,8.79z"
		})
	] })]
});
export default SvgRentFilled;
